import USBubbleMap from './USBubbleMap';

export default USBubbleMap;
